import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { fetchLanguagesData } from '../../../service/languages';
import { createMicroCourse } from '../../../service/micro-course';
import CustomToast from '../../Toast';
import MicroModuleHeader from '../../layouts/microModuleHeader';
import { useNavigate } from 'react-router-dom';
 
const CreateMicroModule = () => {
  const [languages, setLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [courseName, setCourseName] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
 
  const navigate = useNavigate();
 
  useEffect(() => {
    // sessionStorage.clear();
    getLanguages();
  }, []);
 
  const getLanguages = async () => {
    try {
      const languagesData = await fetchLanguagesData();
      if (languagesData.status) {
        setLanguages(languagesData.data);
      } else {
        console.error("Error fetching languages:", languagesData.error);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    }
  };
 
  const handleLanguageChange = (selectedOptions) => {
    setSelectedLanguages(selectedOptions);
    sessionStorage.setItem("selectedLanguages", JSON.stringify(selectedOptions))
  };
 
  const handleMicroCourseNameChange = (courseName) => {
    setCourseName(courseName.target.value);
    sessionStorage.setItem("courseName", courseName.target.value)
 
    console.log("Micro Course Name:", courseName.target.value);
  };
 
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };
 
  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };
 
  const validateForm = () => {
    if (!courseName.trim()) {
      CustomToast.error('Course name is required');
      return false;
    }
    // if (!startDate) {
    //   CustomToast.error('Start date is required');
    //   return false;
    // }
    // if (!endDate) {
    //   CustomToast.error('End date is required');
    //   return false;
    // }
    // if (new Date(startDate) >= new Date(endDate)) {
    //   CustomToast.error('End date must be after start date');
    //   return false;
    // }
    if (selectedLanguages.length === 0) {
      CustomToast.error('Please select at least one language');
      return false;
    }
    return true;
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    if (!validateForm()) {
      return;
    }
 
    setIsLoading(true);
 
    const microCourseData = {
      lngs: selectedLanguages.map(lang => ({
        id: lang.value,
        lang: lang.label
      })),
      name: courseName,
      isMicroModule: true,
     // start_date: startDate,
     // end_date: endDate
    };
 
    try {
      const response = await createMicroCourse(microCourseData);
      if (response.status) {
        // Clear form
        setCourseName('');
        setStartDate('');
        setEndDate('');
        setSelectedLanguages([]);
        // sessionStorage.removeItem("microCourseName");
       // sessionStorage.removeItem("selectedLanguages");
 
        // Navigate to courses list or course details
        navigate('/micro_course_details');
      } else {
        CustomToast.error(response.message || 'Failed to create micro course');
      }
    } catch (error) {
      console.error('Error creating micro course:', error);
      CustomToast.error('An error occurred while creating the course');
    } finally {
      setIsLoading(false);
    }
  };
 
  const languageOptions = languages.map((lang) => ({
    value: lang._id,
    label: lang.name,
  }));
 
  return (
    <>
      <MicroModuleHeader createMicroCourse={handleSubmit}>
 
        <div className='d-flex justify-content-center mt-100'>
          <div className='w-50'>
 
 
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <label htmlFor="name">Course Name *</label>
                  <input
                    type="text"
                    className="form-control mt-2"
                    id="name"
                    value={courseName}
                    onChange={handleMicroCourseNameChange}
                    placeholder="Enter course name"
                    required
                  />
                </div>
 
 
                <div className="form-group mb-4">
                  <label className='mb-2'>Select Languages *</label>
                  <Select
                    isMulti
                    options={languageOptions}
                    value={selectedLanguages}
                    onChange={handleLanguageChange}
                    placeholder="Select languages..."
                  />
                </div>
 
                {/* <div className="row">
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label htmlFor="startDate">Start Date *</label>
                      <input
                        type="date"
                        className="form-control mt-2"
                        id="startDate"
                        value={startDate}
                        onChange={handleStartDateChange}
                      //  required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label htmlFor="endDate">End Date *</label>
                      <input
                        type="date"
                        className="form-control mt-2"
                        id="endDate"
                        value={endDate}
                        onChange={handleEndDateChange}
                        min={startDate}
                       // required
                      />
                    </div>
                  </div>
                </div> */}
              </form>
            </div>
 
          </div>
        </div>
      </MicroModuleHeader>
    </>
  );
};
 
export default CreateMicroModule;